import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { CalendarClock, Loader2 } from "lucide-react";
import { errText, fetchClient, fetchMySalons, setVisitDay } from "@/lib/bf";
import { DAYS } from "./BFClientFields";

const EVERY = [1, 2, 3, 4, 8];

export default function BFVisitDay() {
  const [list, setList] = useState(null);
  const [lead, setLead] = useState("");
  const [cur, setCur] = useState(null);
  const [f, setF] = useState({ visit_day: "", visit_every: 1 });
  const [busy, setBusy] = useState(false);
  useEffect(() => { fetchMySalons().then(setList).catch(() => setList([])); }, []);
  useEffect(() => {
    if (!lead) return;
    setCur(null);
    fetchClient(lead).then((r) => { const c = { visit_day: r.card?.visit_day || "", visit_every: r.card?.visit_every || 1 }; setCur(c); setF(c); }).catch(() => { toast.error("Nu am putut încărca fișa"); setLead(""); });
  }, [lead]);
  const label = (k) => (DAYS.find(([d]) => d === k) || [, "fără zi fixă"])[1];
  const save = () => {
    setBusy(true);
    setVisitDay(lead, f).then(() => { setCur(f); toast.success("Ziua de vizită a fost schimbată. Calendarul și fișa s-au actualizat."); window.dispatchEvent(new Event("bf-plan-changed")); })
      .catch((e) => toast.error(errText(e, "Nu am putut salva"))).finally(() => setBusy(false));
  };
  return (
    <section className="invite-box bf-vd" data-testid="bf-visit-day">
      <h3><CalendarClock size={18} /> Schimbă ziua de vizită</h3>
      <p className="st-hint">Alege salonul și noua zi fixă. Se schimbă în fișa clientului și în luna, săptămâna și ziua ta.</p>
      {!list ? <p className="st-hint"><Loader2 size={14} className="animate-spin" /> Se încarcă…</p> : (
        <select className="bf-vd-salon" value={lead} onChange={(e) => setLead(e.target.value)} data-testid="bf-vd-salon">
          <option value="">Alege salonul…</option>
          {list.map((x) => <option key={x.id} value={x.id}>{x.salon}{x.city ? ` · ${x.city}` : ""}</option>)}
        </select>
      )}
      {lead && !cur && <p className="st-hint"><Loader2 size={14} className="animate-spin" /> Se încarcă fișa…</p>}
      {lead && cur && (
        <div className="bf-vd-form">
          <p className="st-hint" data-testid="bf-vd-current">Acum: <b>{label(cur.visit_day)}</b>{cur.visit_day ? `, ${cur.visit_every === 1 ? "în fiecare săptămână" : `la ${cur.visit_every} săptămâni`}` : ""} · <Link to={`/client/${lead}`} data-testid="bf-vd-open">deschide fișa</Link></p>
          <select value={f.visit_day} onChange={(e) => setF({ ...f, visit_day: e.target.value })} data-testid="bf-vd-day">{DAYS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>
          <select value={f.visit_every} onChange={(e) => setF({ ...f, visit_every: Number(e.target.value) })} data-testid="bf-vd-every">
            {EVERY.map((n) => <option key={n} value={n}>{n === 1 ? "în fiecare săptămână" : `la ${n} săptămâni`}</option>)}
          </select>
          <button type="button" className="st-btn st-btn--silver" onClick={save} disabled={busy || (f.visit_day === cur.visit_day && f.visit_every === cur.visit_every)} data-testid="bf-vd-save">
            {busy ? <Loader2 size={14} className="animate-spin" /> : <CalendarClock size={14} />} Schimbă ziua
          </button>
        </div>
      )}
    </section>
  );
}
